import { render, staticRenderFns } from "./ContactTemplates.vue?vue&type=template&id=7d247c59&"
import script from "./ContactTemplates.vue?vue&type=script&lang=js&"
export * from "./ContactTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports